"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
require("angular-sanitize");
require("angular-resource");
require("angular-messages");
require("angularjs-toaster");
require("angular-ui-bootstrap/dist/ui-bootstrap-csp.css");
require("angular-ui-bootstrap");
require("ui-select/dist/select");
require("ui-select/dist/select.css");
require("angular-ui-router");
require("ng-file-upload");
require("ngstorage");
require("./common/app.common.module");
require("./partner/app.partner.module");
require("./partner/faq/app.faq.subModule");
require("angular/angular-csp.css");
var partnerZoneRequestInterceptor_1 = require("./infrastructure/services/partnerZoneRequestInterceptor");
angular.module('oneClickFactory', [
    'ngSanitize',
    'ngResource',
    'ngStorage',
    //
    'ui.select',
    'ngFileUpload',
    'toaster',
    'oneClickFactory.common',
    'oneClickFactory.partner'
])
    .factory('requestInterceptor', ['$q', '$rootScope', partnerZoneRequestInterceptor_1.partnerZoneRequestInterceptor])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('requestInterceptor');
    }
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYXBwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQW1DO0FBQ25DLDRCQUEwQjtBQUMxQiw0QkFBMEI7QUFDMUIsNEJBQTBCO0FBQzFCLDZCQUEyQjtBQUMzQiwwREFBd0Q7QUFDeEQsZ0NBQThCO0FBQzlCLGlDQUErQjtBQUMvQixxQ0FBbUM7QUFDbkMsNkJBQTJCO0FBQzNCLDBCQUF3QjtBQUN4QixxQkFBbUI7QUFFbkIsc0NBQW9DO0FBQ3BDLHdDQUFzQztBQUN0QywyQ0FBeUM7QUFFekMsbUNBQWdDO0FBR2hDLHlHQUFzRztBQUV0RyxPQUFPLENBQUMsTUFBTSxDQUFDLGlCQUFpQixFQUFFO0lBQzlCLFlBQVk7SUFDWixZQUFZO0lBQ1osV0FBVztJQUNYLEVBQUU7SUFDRixXQUFXO0lBQ1gsY0FBYztJQUNkLFNBQVM7SUFFVCx3QkFBd0I7SUFDeEIseUJBQXlCO0NBQzVCLENBQUM7S0FDRyxPQUFPLENBQUMsb0JBQW9CLEVBQUUsQ0FBQyxJQUFJLEVBQUUsWUFBWSxFQUFFLDZEQUE2QixDQUFDLENBQUM7S0FDbEYsTUFBTSxDQUFDLENBQUMsZUFBZSxFQUFFLFVBQUMsYUFBb0M7UUFDM0QsYUFBYSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsb0JBQW9CLENBQUMsQ0FBQztJQUMxRCxDQUFDO0NBQ0EsQ0FBQyxDQUFDIn0=